import { useRef, useState } from 'react';
import { generarInformeEjecutivo } from '../lib/generarInformeEjecutivo.js';

/**
 * cargarDatos(): Promise<InformeEjecutivoData> | InformeEjecutivoData
 * Debe consultar o reutilizar la fuente de datos existente del dashboard.
 * No se comunica con ChatGPT ni con un servicio externo de generación de PDF.
 */
export default function InformeEjecutivoButton({ cargarDatos, className = '' }) {
  const [generando, setGenerando] = useState(false);
  const ocupado = useRef(false);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');

  async function descargar() {
    if (ocupado.current) return;
    ocupado.current = true;
    setError('');
    setAviso('');
    setGenerando(true);
    try {
      if (typeof cargarDatos !== 'function') {
        throw new Error('Falta conectar cargarDatos con los indicadores del dashboard.');
      }
      const datos = await cargarDatos();
      const resultado = await generarInformeEjecutivo(datos);
      if (resultado.borrador) {
        setAviso('Se ha descargado un borrador. Comprueba los campos pendientes antes de entregarlo al banco.');
      }
    } catch {
      // Los errores del backend pueden contener datos: nunca mostrarlos.
      setError('No se pudo generar el informe. Vuelve a intentarlo.');
    } finally {
      ocupado.current = false;
      setGenerando(false);
    }
  }

  return (
    <div className={`inline-flex flex-col items-start gap-1.5 ${className}`}>
      <button
        type="button"
        onClick={descargar}
        disabled={generando}
        aria-busy={generando}
        className="inline-flex max-w-full items-center gap-2 rounded-lg bg-slate-800 px-4 py-2.5 text-left text-sm font-semibold text-white shadow-sm transition hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700 disabled:cursor-wait disabled:opacity-60"
      >
        <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3v12m0 0 4-4m-4 4-4-4M4 16v4h16v-4" />
        </svg>
        {generando ? 'Generando informe...' : 'Descargar informe financiero'}
      </button>
      {error && <p role="alert" className="max-w-md text-xs text-red-700">{error}</p>}
      {aviso && <p role="status" className="max-w-md text-xs text-amber-700">{aviso}</p>}
    </div>
  );
}
